import { useCallback, useState } from 'react';
import { DEFAULT_LIST_PARAMS, GetUrlParams, ListParams } from '@lib/enums/urls';

export default function useTabListState() {
  const [params, setParams] = useState<ListParams>(() => ({
    ...DEFAULT_LIST_PARAMS,
  }));
  const [searchQuery, setSearchQuery] = useState('');

  const onSearchChange = useCallback((value: string) => {
    setSearchQuery(value);
    setParams((prev) => ({ ...prev, [GetUrlParams.Page]: '1' }));
  }, []);

  const listState: [ListParams, typeof setParams] = [params, setParams];

  return {
    listState,
    params,
    searchQuery,
    onSearchChange,
  };
}
